export default "__VITE_ASSET__yOpSgAAK__"